import { styled, Typography } from '@mui/material'

const H3 = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.main,
  fontFamily: theme.typography?.fontFamily,
  fontWeight: 700,
  fontSize: '1.125rem',
}));

export default H3